import { Breakpoint } from '@/enums'
import { toPixels } from '@/utils/convert'
import { concat } from '@/utils/string'
import { last, keys as objectKeys } from 'ramda'

const MIN = 'min'
const MAX = 'max'

const baseMedia = (bound: string) => `@media (${bound}-width:`

export const createBreakpoints = (breakpoints: Record<Breakpoint, number>) => {
  const keys = objectKeys(breakpoints)

  const up = (key: Breakpoint) => {
    const value = breakpoints[key] || key
    return concat(baseMedia(MIN), toPixels(value), ')')
  }

  const down = (key: Breakpoint) => {
    const value = breakpoints[key] || key
    return concat(baseMedia(MAX), toPixels(value), ')')
  }

  const between = (start: Breakpoint, end: Breakpoint) => {
    if (end === last(keys)) {
      return up(start)
    }

    return concat(
      up(start),
      ' and (max-width:',
      toPixels(breakpoints[end] || end),
      ')',
    )
  }

  const only = (key: Breakpoint) => between(key, key)

  return {
    keys,
    values: breakpoints,
    up,
    down,
    between,
    only,
  }
}
